/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.controller('TwitterOutilsCtrl', function($scope, $http) {
    $scope.tweet      = { };
    $scope.tweet.show = false;

    window.twttr = (function(d, s, id) {
        let fjs;
        let js = (fjs = d.getElementsByTagName(s)[0]);
        const t  = window.twttr || { };

        if (d.getElementById(id)) {
            return t;
        }

        js     = d.createElement(s);
        js.id  = id;
        js.src = '//platform.twitter.com/widgets.js';

        fjs.parentNode.insertBefore(js, fjs);

        t._e = [];

        t.ready = f => t._e.push(f);

        return t;
    })(document, 'script', 'twitter-wjs');

    // On attend que 'twttr' soit bien chargé et on crée une timeline de tweets
    // dans la div Twitter avec les options choisies.
    return twttr.ready(twttr => twttr
    .widgets
    .createTimeline(
        {
            sourceType: 'url',
            url:        'https://twitter.com/outils_etna'
        },
        document.getElementById('twitter'),
        {
            chrome:      'noheader nofooter',
            tweetLimit:  3,
            omit_script: true,
            lang:        'en'
        }
    )
    // Une fois que le tweet a été généré on accède au nouvel ifram généré par le script
    // Et on supprime les tweets qui ont plus d'un jour d'ancienneté
    .then(() => document.querySelectorAll('iframe.twitter-timeline').forEach(function(element) {
        let tweets = $(element.contentDocument.body).find('li.timeline-TweetList-tweet');
        tweets = tweets.filter(function(index, tweet) {
            const cur          = $(tweet);
            const meta         = cur.find('div.timeline-Tweet-metadata');
            const date         = moment(meta.find('time').attr('datetime'));
            const active_tweet = date < moment().subtract(1, 'days');

            if (active_tweet) { cur.remove(); }
            return !active_tweet;
        });

        if (0 !== tweets.length) { return $('#twitter').css('display', ''); }
    })));
});
